import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeSendToFriendModal } from '../actionCreators/uiActionCreators';
import SendToFriendModal from 'dibs-send-to-friend-modal';

export function CatalogSendToFriendModalComponent(props) {
    const { catalogShareImgURL, catalogTitle, pageTypeId, relay, rootId, senderEmail } = props;
    return (
        <div className={'CatalogSendToFriendModal'}>
            <SendToFriendModal
                catalogIds={{
                    rootId,
                    pageTypeId,
                }}
                closeModal={props.closeSendToFriendModal}
                modalOpen
                relay={relay}
                selectedItems={[
                    {
                        src: catalogShareImgURL,
                        title: catalogTitle,
                    },
                ]}
                senderEmail={senderEmail}
                type="CATALOG"
            />
        </div>
    );
}

CatalogSendToFriendModalComponent.defaultProps = {
    catalogShareImgURL: '',
    catalogTitle: '1stDibs Catalog',
    senderEmail: '',
};

CatalogSendToFriendModalComponent.propTypes = {
    // component props
    catalogShareImgURL: PropTypes.string,
    catalogTitle: PropTypes.string,
    pageTypeId: PropTypes.string,
    relay: PropTypes.object,
    rootId: PropTypes.string,
    senderEmail: PropTypes.string,
    // dispatch actions
    closeSendToFriendModal: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
    return {
        closeSendToFriendModal: () => dispatch(closeSendToFriendModal()),
    };
};

export const CatalogSendToFriendModal = connect(
    null,
    mapDispatchToProps
)(CatalogSendToFriendModalComponent);
